// export const API_BASE_URL =
  //process.env.REACT_APP_API_BASE_URL || "https://localhost:7121";

export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://medidigestapi.apphub.co.in';
